import { useMemo, memo } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';

function SectionE() {
    const { t } = useLang('theProduct.SectionE');

    const newProducts = useMemo(() => [
        {
            label: 'NEW',
            productId: 14793566257519,
            variantId: 52234748395887,
            image: 'https://websiteoss.ecoflow.com/upload/image/1784281072261/limbo-1.png',
            title: t('item1_title'),
            btns: [
                {
                    text: t('item_btn'),
                    link: `https://jp.ecoflow.com/products/ecoflow-alternator-charger-600?variant=52234748395887`,
                    type: 'buy',
                }
            ],
            specs: [
                {
                    title: [t('item1_specs_title')],
                    desc: [t('item1_specs_desc')],
                },
                {
                    title: [t('item1_specs_title2')],
                    desc: [t('item1_specs_desc2')],
                },
                {
                    title: [t('item1_specs_title3'), t('item1_specs_title3_1')],
                    desc: [t('item1_specs_desc3')],
                },
                {
                    title: [t('item1_specs_title4')],
                    desc: [t('item1_specs_desc4'), t('item1_specs_desc4_1')],
                },
                {
                    title: [t('item1_specs_title5')],
                    desc: [t('item1_specs_desc5')],
                },
            ]
        },
        {
            label: 'NEW',
            productId: 14793566519663,
            variantId: 52234754785647,
            image: 'https://websiteoss.ecoflow.com/upload/image/1784281081174/limbo-2.png',
            title: t('item2_title'),
            btns: [
                {
                    text: t('item_btn'),
                    link: `https://jp.ecoflow.com/products/ecoflow-alternator-charger-plus-1000?variant=52234754785647`,
                    type: 'buy',
                }
            ],
            specs: [
                {
                    title: [t('item2_specs_title')],
                    desc: [t('item2_specs_desc')],
                },
                {
                    title: [t('item2_specs_title2')],
                    desc: [t('item2_specs_desc2')],
                },
                {
                    title: [t('item2_specs_title3'), t('item2_specs_title3_1')],
                    desc: [t('item2_specs_desc3')],
                },
                {
                    title: [t('item2_specs_title4')],
                    desc: [t('item2_specs_desc4'), t('item2_specs_desc4_1')],
                },
                {
                    title: [t('item2_specs_title5')],
                    desc: [t('item2_specs_desc5')],
                },
            ]
        },
        {
            label: '',
            productId: 0,
            variantId: 0,
            image: 'https://websiteoss.ecoflow.com/upload/image/1784281090651/limbo-3.png',
            title: t('item3_title'),
            btns: [
            ],
            specs: [
                {
                    title: [t('item3_specs_title')],
                    desc: [t('item3_specs_desc')],
                },
                {
                    title: t('item3_specs_title2'),
                    desc: [t('item3_specs_desc2')],
                },
                {
                    title: [t('item3_specs_title3'), t('item3_specs_title3_1')],
                    desc: [t('item3_specs_desc3')],
                },
                {
                    title: [t('item3_specs_title4')],
                    desc: [t('item3_specs_desc4'), t('item3_specs_desc4_1')],
                },
            ]
        },
        {
            label: '',
            productId: 0,
            variantId: 0,
            image: 'https://websiteoss.ecoflow.com/upload/image/1784281100132/limbo-4.png',
            title: t('item4_title'),
            btns: [
            ],
            specs: [
                {
                    title: [t('item4_specs_title')],
                    desc: [t('item4_specs_desc')],
                },
                {
                    title: [t('item4_specs_title2')],
                    desc: [t('item4_specs_desc2')],
                },
                {
                    title: [t('item4_specs_title3'), t('item4_specs_title3_1')],
                    desc: [t('item4_specs_desc3')],
                },
                {
                    title: [t('item4_specs_title4')],
                    desc: [t('item4_specs_desc4'), t('item4_specs_desc4_1')],
                },
            ]
        },
    ], [t]);

    return (
        <div className={`${styles.SectionE} eco-content GtmModuleData-section RV-sectionE`} id="RV-SectionE" data-section-id="on-the-road-SectionE">
            <EcoSpace />

            <div className="title-wrap">
                <h2 className="title-wrap__text">EcoFlow Alternator Charger 製品比較</h2>
            </div>
            <div className="products-wrap">
                {newProducts.map((product) => (
                    <div className="products-wrap__item">
                        <div className="products-wrap__image">
                            <EcoImg pc={product.image} h5={product.image} isOpenLazy />
                        </div>
                        <div className="products-wrap__content">
                            <div className="products-wrap__label">
                                <span className="products-wrap__text-label">{product.label || '\u00A0'}</span>
                            </div>
                            <div className="products-wrap__title">
                                <h3 className="products-wrap__text-title">{product.title}</h3>
                            </div>
                            <div className="products-wrap__btns-wrap">
                                {product.btns && product.btns.length > 0 ? product.btns.map((btn) =>
                                    btn && btn.type === 'buy' ? (
                                        <EcoLink href={btn.link} className="products-wrap__btn">{btn.text}</EcoLink>
                                    ) : (
                                        <EcoLink href={btn.link} className="products-wrap__btn products-wrap__btn-more">{btn.text}<span className="products-wrap__btn-more-icon"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
        <path d="M4.73825e-08 7.06671L4.17676 4.0755L3.08897e-07 1.08396L0.776368 -2.0255e-05L5.70996 3.53351C5.88465 3.65871 5.98828 3.86057 5.98828 4.0755C5.98824 4.29043 5.88469 4.49233 5.70996 4.61749L0.776367 8.1507L4.73825e-08 7.06671Z" fill="black"/>
        </svg></span></EcoLink>
                                    )
                                ) : <div className="products-wrap__btns-placeholder"></div>}
                            </div>
                        </div>
                        <div className="products-wrap__line"></div>
                        <div className="products-wrap__specs">
                            {product.specs && product.specs.map((spec, specIndex) => (
                                <div className="products-wrap__specs-item">
                                    { spec.desc && Array.isArray(spec.desc) ? spec.desc.map((specItem, itemIndex) => {
                                        return <span key={`${specIndex}-${itemIndex}`} className="products-wrap__specs-description">{specItem}</span>
                                    }) : (
                                        <span className="products-wrap__specs-description">{spec.desc}</span>
                                    )}
                                    {spec.title && Array.isArray(spec.title) ? spec.title.map((specTitle, titleIndex) => {
                                        return <span key={`${specIndex}-${titleIndex}`} className="products-wrap__specs-title">{specTitle}</span>
                                    }) : (
                                        <span className="products-wrap__specs-title">{spec.title}</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
}

export default memo(SectionE);
